import React, { Fragment, useState } from "react";
import ReactEmoji from "react-emoji";

import CampaignChatLogo from "../Campaign/CampaignChatLogo";

const MentorModChatMessageItem = ({
  user,
  modmessage,
  modmessages,
  deleteModMessage,
  isAuthenticated,
  profile,
  moderators,
  deleteModerator,
  setReportedUser,
  setShowReportUser,
  TimeOutMod,
  timeoutDeleteModMessage,
}) => {
  const [showModal, setShowModal] = useState(false);

  return (
    <Fragment>
      <div className="chat-message-body">
        <div className="chat-container">
          <div className="chat-user-container">
            <div className="chat-item-containers">
              <img
                src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${modmessage.avatar}`}
                className="chat-avi"
                alt="chatimage"
              />
            </div>
            <div className="chat-item-containers">
              <div className="chat-text">
                <span
                  className={`${
                    profile && profile.role === "innovator"
                      ? "green"
                      : profile && profile.role === "mentor"
                      ? "red"
                      : profile && profile.role === "employer"
                      ? "blue"
                      : ""
                  } mr-5 chat-logo-align`}
                >
                  {modmessage.firstname === "imeBOT" ? (
                    <i className="fa-solid fa-robot chat-logo mr-5"></i>
                  ) : modmessage.founding_supporter_type === "Overwhelming" ? (
                    <CampaignChatLogo />
                  ) : (
                    ""
                  )}
                  {profile.channelid === modmessage.channelid &&
                    isAuthenticated && (
                      <i class="fa-solid fa-crown fa-sm gold mr-5"></i>
                    )}
                  {moderators.map((mod) => {
                    if (mod.channelid === modmessage.channelid) {
                      return (
                        <i
                          class={`fa-solid fa-screwdriver-wrench fa-sm ${
                            modmessage && modmessage.role === "innovator"
                              ? "green"
                              : modmessage && modmessage.role === "mentor"
                              ? "red"
                              : modmessage && modmessage.role === "employer"
                              ? "blue"
                              : ""
                          } mr-5`}
                        ></i>
                      );
                    }
                  })}
                  {modmessage.founding_supporter_type === "Good" &&
                    isAuthenticated &&
                    modmessage.firstname !== "imeBOT" && (
                      <i class="fa-solid fa-1 fa-sm gold mr-5"></i>
                    )}
                  {modmessage.founding_supporter_type === "Great" &&
                    isAuthenticated &&
                    modmessage.firstname !== "imeBOT" && (
                      <i class="fa-solid fa-1 fa-sm gold mr-5"></i>
                    )}
                  {modmessage.founding_supporter_type === "Overwhelming" &&
                    isAuthenticated &&
                    modmessage.firstname !== "imeBOT" && (
                      <div>
                        <i class="fa-solid fa-star fa-sm gold mr-5"></i>
                        <i class="fa-solid fa-1 fa-sm gold mr-5"></i>
                      </div>
                    )}
                  {modmessage.verified && (
                    <div>
                      <i
                        class={`fa-regular fa-circle-check fa-sm ${
                          modmessage && modmessage.role === "innovator"
                            ? "green"
                            : modmessage && modmessage.role === "mentor"
                            ? "red"
                            : modmessage && modmessage.role === "employer"
                            ? "blue"
                            : ""
                        } mr-5`}
                      ></i>
                    </div>
                  )}
                  <span
                    className={` ${
                      modmessage.founding_supporter_type === "Overwhelming"
                        ? "change-name-color"
                        : modmessage && modmessage.role === "innovator"
                        ? "green"
                        : modmessage && modmessage.role === "mentor"
                        ? "red"
                        : modmessage && modmessage.role === "employer"
                        ? "blue"
                        : ""
                    }`}
                  >
                    {modmessage.firstname === "imeBOT"
                      ? modmessage.firstname
                      : modmessage.channelid}{" "}
                    {"\n"}
                  </span>{" "}
                </span>
                <span
                  className={`${
                    modmessage.deleted
                      ? "italicized red"
                      : modmessage.timedout
                      ? "italicized red"
                      : "max-text-width"
                  } 
                  `}
                >
                  {ReactEmoji.emojify(modmessage.text)}
                  {modmessage.gif !== "" && (
                    <img
                      src={modmessage.gif}
                      alt="avatar"
                      className="selected-gif"
                    />
                  )}
                </span>
              </div>
            </div>
          </div>
          {modmessage.firstname !== "imeBOT" &&
            !modmessage.deleted &&
            !modmessage.timedout &&
            !showModal && (
              <div className="chat-item-modal-containers">
                <div className="chat-user-info">
                  <i
                    onClick={() => {
                      if (showModal) {
                        setShowModal(false);
                      } else {
                        setShowModal(true);
                      }
                    }}
                    className="fas fa-ellipsis-v mx-10 red cursor"
                  ></i>
                </div>
              </div>
            )}
        </div>
        <div className="center">
          {modmessage.firstname !== "imeBOT" &&
            !modmessage.deleted &&
            showModal &&
            isAuthenticated && (
              <div className="chat-item-modal-containers">
                <div className="chat-modal">
                  <ul className="modal-items">
                    {user.channelid === profile.channelid &&
                      showModal &&
                      moderators &&
                      moderators.length > 0 &&
                      moderators.map((mod) => {
                        if (mod.channelid === modmessage.channelid) {
                          return (
                            <li
                              onClick={() => {
                                deleteModerator(modmessage.channelid);
                                setShowModal(false);
                              }}
                              className="modal-item"
                            >
                              <i
                                className={`fa-solid fa-screwdriver mx-5 ${
                                  profile && profile.role === "innovator"
                                    ? "green"
                                    : profile && profile.role === "mentor"
                                    ? "red"
                                    : profile && profile.role === "employer"
                                    ? "blue"
                                    : ""
                                }`}
                              ></i>
                              Delete Mod
                            </li>
                          );
                        } else if (
                          mod.channelid !== "" &&
                          mod.channelid !== modmessage.channelid
                        ) {
                          return null;
                        }
                      })}
                    {user.channelid === profile.channelid &&
                      showModal &&
                      user.channelid !== modmessage.channelid && (
                        <li
                          onClick={() => {
                            TimeOutMod(modmessage, profile, modmessages);
                            timeoutDeleteModMessage(modmessage);
                            setShowModal(false);
                          }}
                          className="modal-item"
                        >
                          <i
                            className={`fa-solid fa-hourglass-half mx-5 ${
                              profile && profile.role === "innovator"
                                ? "green"
                                : profile && profile.role === "mentor"
                                ? "red"
                                : profile && profile.role === "employer"
                                ? "blue"
                                : ""
                            }`}
                          ></i>
                          Timeout
                        </li>
                      )}
                    {user.channelid !== profile.channelid &&
                      showModal &&
                      moderators.map((mod) => {
                        if (
                          mod.channelid === user.channelid &&
                          mod.level === "Senior" &&
                          mod.channelid !== modmessage.channelid
                        ) {
                          return (
                            <li
                              onClick={() => {
                                TimeOutMod(modmessage, profile, modmessages);
                                timeoutDeleteModMessage(modmessage);
                                setShowModal(false);
                              }}
                              className="modal-item"
                            >
                              <i
                                className={`fa-solid fa-hourglass-half mx-5 ${
                                  profile && profile.role === "innovator"
                                    ? "green"
                                    : profile && profile.role === "mentor"
                                    ? "red"
                                    : profile && profile.role === "employer"
                                    ? "blue"
                                    : ""
                                }`}
                              ></i>
                              Timeout
                            </li>
                          );
                        }
                      })}
                    {modmessage.channelid === user.channelid && showModal && (
                      <li
                        onClick={() => {
                          deleteModMessage(modmessage, modmessages);
                          setShowModal(false);
                        }}
                        className="modal-item"
                      >
                        <i
                          className={`fas fa-times mx-5 ${
                            profile && profile.role === "innovator"
                              ? "green"
                              : profile && profile.role === "mentor"
                              ? "red"
                              : profile && profile.role === "employer"
                              ? "blue"
                              : ""
                          }`}
                        ></i>
                        Delete
                      </li>
                    )}
                    {moderators.map((mod) => {
                      if (
                        mod.channelid === user.channelid &&
                        user.channelid !== modmessage.channelid
                      ) {
                        return (
                          <li
                            onClick={() =>
                              deleteModMessage(modmessage, modmessages)
                            }
                            className="modal-item"
                          >
                            <i
                              className={`fas fa-times mx-5 ${
                                profile && profile.role === "innovator"
                                  ? "green"
                                  : profile && profile.role === "mentor"
                                  ? "red"
                                  : profile && profile.role === "employer"
                                  ? "blue"
                                  : ""
                              }`}
                            ></i>
                            Delete
                          </li>
                        );
                      }
                    })}
                    {modmessage.channelid !== user.channelid &&
                      user.channelid === "roland" &&
                      showModal && (
                        <li
                          onClick={() => {
                            deleteModMessage(modmessage, modmessages);
                            setShowModal(false);
                          }}
                          className="modal-item"
                        >
                          <i
                            className={`fas fa-times mx-5 ${
                              profile && profile.role === "innovator"
                                ? "green"
                                : profile && profile.role === "mentor"
                                ? "red"
                                : profile && profile.role === "employer"
                                ? "blue"
                                : ""
                            }`}
                          ></i>
                          Delete
                        </li>
                      )}
                    {modmessage.channelid !== user.channelid && showModal && (
                      <li
                        onClick={() => {
                          setShowReportUser({ submit: true, confirm: false });
                          setReportedUser({
                            role: modmessage.role,
                            channelid: modmessage.channelid,
                            avatar: modmessage.avatar,
                            firstname: modmessage.firstname,
                            lastname: modmessage.lastname,
                            text: modmessage.text,
                            image: "",
                            video: "",
                            gif: modmessage.gif !== "" ? modmessage.gif : "",
                          });
                          setShowModal(false);
                        }}
                        className="modal-item"
                      >
                        <i
                          className={`fas fa-flag mx-5 ${
                            profile && profile.role === "innovator"
                              ? "green"
                              : profile && profile.role === "mentor"
                              ? "red"
                              : profile && profile.role === "employer"
                              ? "blue"
                              : ""
                          }`}
                        ></i>
                        Report
                      </li>
                    )}
                    {user.channelid === "roland" &&
                      user.channelid !== modmessage.channelid &&
                      showModal && (
                        <li className="modal-item">
                          <i
                            className={`fas fa-ban mx-5 ${
                              profile && profile.role === "innovator"
                                ? "green"
                                : profile && profile.role === "mentor"
                                ? "red"
                                : profile && profile.role === "employer"
                                ? "blue"
                                : ""
                            }`}
                          ></i>
                          Ban
                        </li>
                      )}
                  </ul>
                </div>
                <div className="chat-user-info">
                  <i
                    onClick={() => {
                      if (showModal) {
                        setShowModal(false);
                      } else {
                        setShowModal(true);
                      }
                    }}
                    className="fas fa-ellipsis-v mx-10 red cursor"
                  ></i>
                </div>
              </div>
            )}
        </div>
      </div>
    </Fragment>
  );
};

export default MentorModChatMessageItem;
